import type { RankedSpace } from "../types";

export function computeVisibleSpaces(
  allSpaces: RankedSpace[],
  allOutdatedSpaces: RankedSpace[],
  showOtherSpaces: boolean,
  showOutdatedSpaces: boolean,
  selectedSpaceIds: string[],
): RankedSpace[] {
  const selectedIds = new Set(selectedSpaceIds);
  return [
    ...(showOtherSpaces
      ? allSpaces
      : allSpaces.filter((s) => s.score >= 80 || selectedIds.has(s.id))),
    ...(showOutdatedSpaces ? allOutdatedSpaces : []),
  ];
}
